require('./brokerHireInvestmentFund.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const {BrokerHireInvestmentFundWithContribution} = require('./components/withContribution');
const { BrokerHireInvestmentFundWithoutContribution }  = require ('./components/withoutContribution');

// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ constants
const { catalogue, analyticsId } = require('../analytics/brokerHireInvestmentFund.tracking');

class BrokerHireInvestmentFund extends React.Component {
    constructor(props) {
        super(props);
    }

    buildWithContribution() {
        return(
            <BrokerHireInvestmentFundWithContribution
                setWillCancel={this.props.setWillCancel}
                onCancel={() => this.props.onCancel()}
                onFinish={()=>this.props.onFinish()}
                wizzardTitle={this.props.wizzardTitle}
                immAccounts={this.props.immAccounts}
                immBlockedAccountsIds={this.props.immBlockedAccountsIds}
                immStocksContractForm={this.props.immStocksContractForm}
                immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                immFlagBasedFeatures={this.props.immFlagBasedFeatures}
                handleAccountChange={this.props.handleAccountChange}
                handleSetAmount={this.props.handleSetAmount}
                accountSelected={this.props.accountSelected}
                setIntervenerName={this.props.setIntervenerName}
                setIntervenerType={this.props.setIntervenerType}
                addIntervener={this.props.addIntervener}
                removeIntervener={this.props.removeIntervener}
                restoreDefaultInterveners={this.props.restoreDefaultInterveners}
                isBlockedAccountsLoading={this.props.isBlockedAccountsLoading}
                handleChangeContract={this.props.handleChangeContract}
                setIsSubscription={this.props.setIsSubscription}
                setIsNewContract={this.props.setIsNewContract}
                validateSchema={this.props.validateSchema}
                getIntervenersContractByContractNumber={this.props.getIntervenersContractByContractNumber}
                fundId={this.props.fundId}
                extantDataFetch={this.props.extantDataFetch}
                onStepChange={this.props.onStepChange}
            />
        )

    }

    buildWithoutContribution() {
        return (
            <BrokerHireInvestmentFundWithoutContribution
                validateStep={this.props.validateStep}
                setVisibleStep={this.props.setVisibleStep}
                immInvestmentFunds={this.props.immInvestmentFunds}
                setWillCancel={this.props.setWillCancel}
                onCancel={() => this.props.onCancel()}
                onFinish={()=>this.props.onFinish()}
                wizzardTitle={this.props.wizzardTitle}
                immAccounts={this.props.immAccounts}
                immBlockedAccountsIds={this.props.immBlockedAccountsIds}
                immStocksContractForm={this.props.immStocksContractForm}
                immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                immFlagBasedFeatures={this.props.immFlagBasedFeatures}
                handleAccountChange={this.props.handleAccountChange}
                handleSetAmount={this.props.handleSetAmount}
                accountSelected={this.props.accountSelected}
                setIntervenerName={this.props.setIntervenerName}
                setIntervenerType={this.props.setIntervenerType}
                addIntervener={this.props.addIntervener}
                removeIntervener={this.props.removeIntervener}
                restoreDefaultInterveners={this.props.restoreDefaultInterveners}
                isBlockedAccountsLoading={this.props.isBlockedAccountsLoading}
                handleChangeContract={this.props.handleChangeContract}
                setIsSubscription={this.props.setIsSubscription}
                setIsNewContract={this.props.setIsNewContract}
                validateSchema={this.props.validateSchema}
                getIntervenersContractByContractNumber={this.props.getIntervenersContractByContractNumber}
                fundId={this.props.fundId}
                extantDataFetch={this.props.extantDataFetch}
                onStepChange={this.props.onStepChange}
            />
        )
    }

    render() {
        const { immFlagBasedFeatures, immBrokerMyInvestments, immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);
        const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
        const content = ffContribution && !isSubscription ? this.buildWithContribution() : this.buildWithoutContribution();
        return content
    }
}

BrokerHireInvestmentFund.propTypes = {
    fundId: PropTypes.string,
    immBlockedAccountsIds: PropTypes.object,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immSteps: PropTypes.object,
    immInvestmentFunds: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    isBlockedAccountsLoading: PropTypes.bool.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    accountSelected: PropTypes.string,
    handleAccountChange: PropTypes.func.isRequired,
    handleSetAmount: PropTypes.func.isRequired,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    onReadCheckedStep1: PropTypes.func.isRequired,
    wizzardTitle: PropTypes.object,
    handleChangeContract: PropTypes.func,
    setIsSubscription: PropTypes.func,
    setIsNewContract: PropTypes.func,
    validateSchema: PropTypes.func,
    extantDataFetch: PropTypes.func,
    onStepChange: PropTypes.func,
};

module.exports = BrokerHireInvestmentFund;
